import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { Box, Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { TaxonomyImportPageObjectModel } from '@/poms/taxonomyImportPageObjectModel';

interface ImportResultStepProperties {
  success: boolean;
  message: string;
  onClose: () => void;
}

export const ImportResultStep = ({ success, message, onClose }: ImportResultStepProperties) => (
  <>
    <DialogContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2, gap: 2 }}>
        {success ? (
          <CheckCircleOutline sx={{ fontSize: '48px', color: 'success.main' }} />
        ) : (
          <ErrorOutline sx={{ fontSize: '48px', color: 'error.main' }} />
        )}
        <Typography
          variant='body1'
          sx={{ textAlign: 'center' }}
          data-testid={TaxonomyImportPageObjectModel.ResultMessage}
        >
          {message}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button variant='contained' onClick={onClose} data-testid={TaxonomyImportPageObjectModel.ResultCloseButton}>
        {success ? 'Done' : 'Close'}
      </Button>
    </DialogActions>
  </>
);
